function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React from 'react';
import { Field } from 'formik';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import GenericFormElement from '../GenericFormElement';
import { useExtendedFormikContext } from '../FormikWrapper';
import './style.scss';
function Checkbox(props) {
  var name = props.name,
    value = props.value,
    validate = props.validate,
    disabled = props.disabled,
    className = props.className,
    _onChange = props.onChange;
  return /*#__PURE__*/React.createElement(Field, {
    required: true,
    name: name,
    value: value,
    validate: validate
  }, function (_ref) {
    var field = _ref.field,
      form = _ref.form;
    var name = "".concat(props.name, "--").concat(props.value);
    var checked = field.value && field.value.includes(value);
    var classes = c('WebformCheckboxes__checkbox__input', {
      'icon-before': true,
      'icon-checkmark': true,
      'icon-variant-0': !checked,
      'icon-variant-1': checked,
      'disabled': disabled
    });
    var checkedValues = function checkedValues() {
      // The value we return here is based on the current state, meaning,
      // before we update it using setFieldValue. Therefore, when the current
      // value is unchecked, we want to add it to the list of checked values.
      // And if the current value is checked, we want to filter it out of the
      // list of checked values.

      if (!checked) {
        if (field.value === undefined || field.value === null) {
          return [value];
        }
        return [].concat(_toConsumableArray(field.value), [value]);
      }
      return field.value.filter(function (item) {
        return item !== value;
      });
    };
    if (props.value === '__other__') {
      var inputClasses = c({
        hidden: !field.value.includes('__other__')
      });
      return /*#__PURE__*/React.createElement("label", {
        className: classes,
        htmlFor: name
      }, /*#__PURE__*/React.createElement("input", _extends({}, field, {
        name: props.name,
        value: value,
        type: "checkbox",
        id: name,
        checked: checked,
        disabled: disabled,
        className: className,
        onChange: function onChange(event) {
          if (_onChange) {
            _onChange(value, checkedValues());
          }
          field.onChange(event);
        }
      })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", null, props.otherLabel ? props.otherLabel : props.label), props.description && /*#__PURE__*/React.createElement("span", null, props.description)), /*#__PURE__*/React.createElement("textarea", {
        placeholder: props.otherPlaceholder,
        className: inputClasses,
        onChange: function onChange(e) {
          form.setFieldValue("".concat(props.name, "--other"), e.target.value);
        }
      }));
    }
    return /*#__PURE__*/React.createElement("label", {
      className: classes,
      htmlFor: name
    }, /*#__PURE__*/React.createElement("input", _extends({}, field, {
      name: props.name,
      value: value,
      type: "checkbox",
      id: name,
      checked: checked,
      disabled: disabled,
      className: className,
      onChange: function onChange(event) {
        if (_onChange) {
          _onChange(value, checkedValues());
        }
        field.onChange(event);
      }
    })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", null, props.label), props.description && /*#__PURE__*/React.createElement("span", null, props.description)));
  });
}
var Checkboxes = function Checkboxes(props) {
  var title = props.title,
    required = props.required,
    description = props.description,
    placeholder = props.placeholder,
    fieldName = props.fieldName,
    validation = props.validation,
    type = props.type,
    options = props.options,
    _props$descriptions = props.descriptions,
    descriptions = _props$descriptions === void 0 ? {} : _props$descriptions,
    className = props.className,
    wrapperClassName = props.wrapperClassName,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    otherLabel = props.otherLabel,
    otherPlaceholder = props.otherPlaceholder,
    onChange = props.onChange;
  var _useExtendedFormikCon = useExtendedFormikContext(),
    errors = _useExtendedFormikCon.errors,
    touched = _useExtendedFormikCon.touched,
    displayRequiredIndicator = _useExtendedFormikCon.displayRequiredIndicator;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isTouched = touched[fieldName];
  var error = errors[fieldName];
  var handleValidation = function handleValidation(value) {
    if (validation) {
      return validation(value);
    }
    if (required && (!value || !Array.isArray(value) || value.length === 0)) {
      return t(['webform.components.checkboxes.required', 'webform.required', 'webform_required']);
    }
  };
  return /*#__PURE__*/React.createElement(GenericFormElement, {
    className: c('Checkboxes', wrapperClassName),
    title: title,
    required: required,
    description: description,
    fieldName: fieldName,
    touched: isTouched,
    error: error,
    displayRequiredIndicator: displayRequiredIndicator
  }, Object.keys(options).map(function (item) {
    var label = _typeof(options[item]) === 'object' ? options[item].label : options[item];
    var value = _typeof(options[item]) === 'object' ? options[item].value : item;
    var optionDisabled = disabled || _typeof(options[item]) === 'object' && options[item].disabled;
    var description = descriptions[value] || _typeof(options[item]) === 'object' && options[item].description || null;
    return /*#__PURE__*/React.createElement(Checkbox, {
      key: value,
      label: label,
      description: description,
      className: c(className, {
        'error': error && isTouched
      }),
      name: fieldName,
      type: type || 'text',
      value: value,
      placeholder: placeholder,
      validate: handleValidation,
      disabled: optionDisabled,
      otherLabel: otherLabel,
      otherPlaceholder: otherPlaceholder,
      onChange: onChange
    });
  }));
};
export default Checkboxes;